module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Tab', {
    attrs: {
      "title": _vm.$trad.brand.navigation.general
    }
  }, [_c('TextInputBloc', {
    attrs: {
      "label": _vm.$t('brand.name'),
      "min-length": _vm.MIN_LENGTH_NAME,
      "required": true
    },
    model: {
      value: (_vm.datas.name),
      callback: function($$v) {
        _vm.datas.name = $$v
      },
      expression: "datas.name"
    }
  }), _vm._v(" "), _c('FormSectionTitle', {
    attrs: {
      "title": 'Images'
    }
  }), _vm._v(" "), _c('ImageUploadBloc', {
    attrs: {
      "origin": _vm.logoPath,
      "required": true,
      "label": 'Logo Image'
    },
    model: {
      value: (_vm.datas.logo),
      callback: function($$v) {
        _vm.datas.logo = $$v
      },
      expression: "datas.logo"
    }
  }), _vm._v(" "), _c('ImageUploadBloc', {
    attrs: {
      "origin": _vm.heroImgPath,
      "label": 'Hero Image'
    },
    model: {
      value: (_vm.datas.heroImg),
      callback: function($$v) {
        _vm.datas.heroImg = $$v
      },
      expression: "datas.heroImg"
    }
  }), _vm._v(" "), _c('FormSectionTitle', {
    attrs: {
      "title": 'Look and feel'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-4 col-form-label label"
  }, [_vm._v(_vm._s(_vm.$t("brand.brandTheme")))]), _vm._v(" "), _c('div', {
    staticClass: "col-8 themeBloc"
  }, [_c('span', {
    staticClass: "themeSelecter lightTheme",
    class: [_vm.datas.theme === 'light' ? 'choosen' : ''],
    on: {
      "click": function($event) {
        _vm.selectTheme('light');
      }
    }
  }, [_vm._v("\n                Light")]), _vm._v(" "), _c('span', {
    staticClass: "themeSelecter darkTheme",
    class: [_vm.datas.theme === 'dark' ? 'choosen' : ''],
    on: {
      "click": function($event) {
        _vm.selectTheme('dark');
      }
    }
  }, [_vm._v(" Dark ")])])]), _vm._v(" "), _c('FormSectionTitle', {
    attrs: {
      "title": _vm.$t('brand.colorTitle'),
      "description": _vm.$t('brand.colorFormatInfo')
    }
  }), _vm._v(" "), _c('TextInputBloc', {
    attrs: {
      "label": ("1 (" + (_vm.$t('brand.backgroundColor')) + ")"),
      "required": true,
      "validator": _vm.FORM_VALIDATORS.color,
      "max-length": _vm.MAX_LENGTH_COLOR
    },
    model: {
      value: (_vm.datas.backgroundColor),
      callback: function($$v) {
        _vm.datas.backgroundColor = $$v
      },
      expression: "datas.backgroundColor"
    }
  }), _vm._v(" "), _c('TextInputBloc', {
    attrs: {
      "label": ("2 (" + (_vm.$t('brand.linkColor')) + ")"),
      "required": true,
      "validator": _vm.FORM_VALIDATORS.color,
      "max-length": _vm.MAX_LENGTH_COLOR
    },
    model: {
      value: (_vm.datas.linksColor),
      callback: function($$v) {
        _vm.datas.linksColor = $$v
      },
      expression: "datas.linksColor"
    }
  }), _vm._v(" "), _c('TextInputBloc', {
    attrs: {
      "label": ("3 (" + (_vm.$t('brand.rem3rchLogo')) + ")"),
      "required": true,
      "validator": _vm.FORM_VALIDATORS.color,
      "max-length": _vm.MAX_LENGTH_COLOR
    },
    model: {
      value: (_vm.datas.thirdColor),
      callback: function($$v) {
        _vm.datas.thirdColor = $$v
      },
      expression: "datas.thirdColor"
    }
  }), _vm._v(" "), _c('TextInputBloc', {
    attrs: {
      "label": ("4 (" + (_vm.$t('brand.fourthColor')) + ")"),
      "required": true,
      "validator": _vm.FORM_VALIDATORS.color,
      "max-length": _vm.MAX_LENGTH_COLOR
    },
    model: {
      value: (_vm.datas.fourthColor),
      callback: function($$v) {
        _vm.datas.fourthColor = $$v
      },
      expression: "datas.fourthColor"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-649ef7e6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/brand/tabs/GeneralForm.vue
// module id = 3233
// module chunks = 0